export enum CommunicationModalComponents {
  UserNotified,
  ReminderMessage,
  EmailWillBeSentWhenUserIsAssignedToTom,
  WaitingForNHDetails,
}
